module.exports = __webpack_public_path__ + "img/11.5dc5c8ec.png";